import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Typography,
    Tooltip
} from '@mui/material';
import { Box, Modal, Button, Menu, MenuItem } from '@mui/material';
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import plusIcon from '@iconify/icons-mdi/eye-circle-outline';
import editIcon from '@iconify/icons-mdi/square-edit-outline';
import deleteIcon from '@iconify/icons-mdi/trash-can-outline';
import closeIcon from '@iconify/icons-mdi/close-circle-outline';
import { getData, deleteData, postData, uploadFile, putData } from '../../../webService/webservice.js';
import "../../../styles/Auth/service.css";
import ViewServicePopup from './ViewServicePopup.jsx';
import CreatableSelect from "react-select/creatable";
import makeAnimated from "react-select/animated";
import MembershipMultiSelectAsync from '../../Challange/MemberShipMultiSelect.jsx';
import TVFMLoader from "../Loader/loader.jsx";
import { useStore } from "../../../Context/context.jsx";
import AddStoreForm from "../store/AddStoreForm.jsx";
import StoreMultiSelect from "../../Challange/storeMultiSelect.jsx";
import Link from '@mui/material/Link';
import Footer from "../Footer/Footer-page.jsx";
import StoreSingleAllStoresSelect, { ALL_STORE_OPTION } from "../../Challange/StoreSingleAllStoresSelect.jsx";
import ServiceCategorySelect from "../../Challange/ServiceCategorySelect.jsx";
import ServiceSubCategorySelect from "../../Challange/ServiceSubCategorySelect.jsx";
import AddServiceCategoryForm from "../ServiceCategory/AddServiceCategoryForm.jsx";
import AddServiceSubCategoryForm from "../ServiceSubCategory/AddSubCategoryForm.jsx";
import StockImagePicker from "../../../components/Common/ImagePicker/StockImagePicker.jsx";
const ServicePage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const isAddService = location.pathname === '/services/add';
    const role = localStorage.getItem("role");
    const adminStoreIds = JSON.parse(localStorage.getItem("storeIds") || "[]");
    const initialStoreId = adminStoreIds[0] || "";
    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        textAlign: 'center'
    };
    const headings = [
        'S.No',
        'Image',
        'Name',
        'Location',
        'Price',
        'Status',
        'Action',
    ];
    const serviceCategoryOptions = [
        { value: 'HairCut', label: 'Hair Cut' },
        { value: 'SkinCare', label: 'Skin Care' },
        { value: 'Spa', label: 'SPA' },
        { value: 'Bridal', label: 'Bridal' },
        { value: 'NailArt', label: 'Nail Art' },
        { value: 'Makeup', label: 'Makeup' },
        { value: 'BodyMassage', label: 'Body Massage' },
    ];
    const fileInputRef = useRef(null);
    const [actionAnchorEl, setActionAnchorEl] = useState(null);
    const isActionMenuOpen = Boolean(actionAnchorEl);
    const handleActionClick = (event) => {
        setActionAnchorEl(event.currentTarget);
    };
    const handleActionClose = () => {
        setActionAnchorEl(null);
    };
    const [previewUrl, setPreviewUrl] = useState(null);
    const [serviceImage, setServiceImage] = useState(null);
    const [services, setServices] = useState([]);
    const [viewServiceData, setViewServiceData] = useState(null);
    const [servicesToDelete, setServicesToDelete] = useState(null);
    const [openViewPopup, setOpenViewPopup] = useState(false);
    const [loading, setLoading] = useState(false);
    const [stores, setStores] = useState([]);
    const [refreshKey, setRefreshKey] = useState(0);
    const [categoryRefreshKey, setCategoryRefreshKey] = useState(0);
    const [subCategoryRefreshKey, setSubCategoryRefreshKey] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [open, setOpen] = useState(false);
    const sessionToken = localStorage.getItem("Token");
    const userId = localStorage.getItem("userId");
    const [searchInput, setSearchInput] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [limit, setLimit] = useState(5);
    const [isPopupMode, setIsPopupMode] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editServiceId, setEditserviceId] = useState(null);
    const [errors, setErrors] = useState({});
    const [sortField, setSortField] = useState("createdAt");
    const [sortOrder, setSortOrder] = useState(-1);
    const [isAddStore, setIsAddStore] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [loaderText, setLoaderText] = useState('');
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [store, setStore] = useState(ALL_STORE_OPTION);
    const [isAddCategory, setIsAddCategory] = useState(false);
    const [isAddSubCategory, setIsAddSubCategory] = useState(false);
    const [uploadMethod, setUploadMethod] = useState("Normal");
    const [showStockPicker, setShowStockPicker] = useState(false);
    const [selectedStockImage, setSelectedStockImage] = useState(null);
    const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));
    const sort = [[sortField, sortOrder]];
    const [isGSTVerified, setIsGSTVerified] = useState(false);
    const handleSort = (field) => {
        const newOrder =
            sortField === field ? (sortOrder === 1 ? -1 : 1) : -1;

        setSortField(field);
        setSortOrder(newOrder);
    };
    const { selectedStoreId, setSelectedStoreId } = useStore();
    const [formData, setFormData] = useState({
        storeId: initialStoreId,
        storeName: "", // Initialize storeName
        serviceName: '',
        serviceCode: '',
        serviceImageObject: '',
        serviceCategoryId: '',
        serviceCategoryName: '',
        serviceSubCategoryId: '',
        serviceSubCategoryName: '',
        serviceStatus: '',
        gstPercentage: "",
        gstAmount: "",
        basePrice: "",
        duration: '',
        nonMemberShipPrice: '',
        memberShipPrice: '',
        description: ''
    });

    useEffect(() => {
        const fetchStoreDetails = async () => {
            try {
                if (!formData.storeId) return;

                const res = await getData(
                    `stores/store/${formData.storeId}`,
                    {},
                    sessionToken
                );

                console.log("STORE RESPONSE", res?.data);

                if (res?.data) {

                    setFormData(prev => ({
                        ...prev,
                        storeName: prev.storeName || res.data.storeName
                    }));

                    const gstValid =
                        res.data?.gstData?.valid === true;

                    console.log("GST VERIFIED =", gstValid);

                    setIsGSTVerified(gstValid);
                }
            } catch (err) {
                console.error("Failed to fetch store details", err);
            }
        };

        fetchStoreDetails();
    }, [formData.storeId]);

    useEffect(() => {
        if (!isGSTVerified) {
            setFormData(prev => ({
                ...prev,
                gstPercentage: 0,
                gstAmount: "0.00"
            }));
        }
    }, [isGSTVerified]);

    const EMPTY_ARRAY = [];

    const loadStores = async (inputValue, loadedOptions, { page }) => {
        try {
            const res = await getData(
                "stores/stores",
                { page, limit: 100000, search: inputValue },
                sessionToken
            );

            const results = res?.data?.results || EMPTY_ARRAY;

            const options = results.map(store => ({
                value: store._id,
                label: store.storeName
            }));

            return {
                options,
                hasMore: results.length === 1000,
                additional: { page: page + 1 }
            };

        } catch (err) {
            console.error("Store Fetch Failed", err);
            return { options: [], hasMore: false };
        }
    };

    const loadServiceCategories = async (inputValue, loadedOptions, { page }) => {
        try {
            const params = {
                page,
                limit: 100000,
                search: inputValue,
                storeId: Array.isArray(formData.storeId) ? formData.storeId[0] : formData.storeId
            };
            const token = localStorage.getItem("Token");
            const res = await getData('servicecategories/service-categories', params, token);
            const results = res?.data?.results?.[0]?.paginatedResults || [];
            const options = results.map(cat => ({ value: cat._id, label: cat.serviceCategoryName }));
            return { options, hasMore: results.length === 1000, additional: { page: page + 1 } };
        } catch (err) {
            return { options: [], hasMore: false };
        }
    };

    const loadServiceSubCategories = async (inputValue, loadedOptions, { page }, categoryId) => {
        try {
            const params = {
                page,
                limit: 100000,
                search: inputValue,
                serviceCategoryId: categoryId, // Filter by Category
                storeId: Array.isArray(formData.storeId) ? formData.storeId[0] : formData.storeId
            };
            const token = localStorage.getItem("Token");
            const res = await getData('servicesubcategories/service-subcategories', params, token);
            let results = res?.data?.results?.[0]?.paginatedResults || [];

            // 🛡️ Client-side filter fallback (in case API doesn't filter perfectly)
            if (categoryId) {
                results = results.filter(sub => {
                    const subCatId = sub.serviceCategoryId?._id || sub.serviceCategoryId;
                    return subCatId === categoryId;
                });
            }

            const options = results.map(sub => ({ value: sub._id, label: sub.serviceSubCategoryName }));
            return { options, hasMore: results.length === 1000, additional: { page: page + 1 } };
        } catch (err) {
            return { options: [], hasMore: false };
        }
    };

    const handleRemoveImage = () => {
        setPreviewUrl(null);
        setServiceImage(null);
        setSelectedStockImage(null);
        setFormData(prev => ({ ...prev, serviceImageObject: null }));
    };

    const handleStockSelect = (imageObject) => {
        if (!imageObject) return;
        setSelectedStockImage(imageObject);
        const baseUrl = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
        const uri = imageObject.uri || imageObject.fileObject?.uri || "";
        if (uri) {
            setPreviewUrl(`${baseUrl}/${uri.replace(/^\/+/, "")}`);
        }
        setShowStockPicker(false);
        setErrors(prev => ({ ...prev, serviceImage: null }));
    };

    const handleAddService = async (e) => {
        e.preventDefault();

        const validationErrors = validateFields(formData, uploadMethod, serviceImage, selectedStockImage);
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setErrors({});
        setShowLoader(true);

        try {
            const token = localStorage.getItem("Token");
            const userId = localStorage.getItem("userId");

            let serviceImageObject = null;

            if (uploadMethod === "Normal") {
                if (serviceImage && userId) {
                    const uploadResult = await uploadFile(`files/upload/${userId}`, serviceImage);
                    if (uploadResult?.status === 200) {
                        serviceImageObject = uploadResult.data;
                    } else {
                        toast.error(uploadResult?.message || "Image upload failed");
                        setShowLoader(false);
                        return;
                    }
                }
            } else {
                serviceImageObject = selectedStockImage;
            }

            const isAct = (formData.serviceStatus || "Active") === "Active";
            const serviceData = {
                storeId: formData.storeId,
                serviceName: formData.serviceName,
                serviceCode: formData.serviceCode,
                serviceCategory: formData.serviceCategoryId, // Send ID
                serviceSubCategory: formData.serviceSubCategoryId, // Send ID
                serviceStatus: formData.serviceStatus || "Active",
                isActive: isAct,
                gstPercentage: Number(formData.gstPercentage || 0),
                gstAmount: Number(formData.gstAmount || 0),
                duration: Number(formData.duration),
                nonMemberShipPrice: Number(formData.nonMemberShipPrice),
                memberShipPrice: Number(formData.memberShipPrice),
                description: formData.description || "",
                ...(serviceImageObject && { serviceImageObject }),
                imageSource: uploadMethod
            };

            console.log("Sending service data:", serviceData);

            const response = await postData("services/", serviceData, token);
            toast.success(response.message || "Service added successfully");

            // ✅ Reset
            setFormData(prev => ({
                ...prev,
                serviceName: "",
                serviceCode: "",
                serviceCategory: "",
                serviceCategoryId: "",
                serviceCategoryName: "",
                serviceSubCategoryId: "",
                serviceSubCategoryName: "",
                serviceStatus: "",
                gstPercentage: "",
                gstAmount: "",
                duration: "",
                basePrice: "",
                nonMemberShipPrice: "",
                memberShipPrice: "",
                description: "",
            }));
            setSelectedStockImage(null);
            fetchServices();
            setServiceImage(null);
            setPreviewUrl(null);
            navigate("/services");
            triggerRefresh();

        } catch (error) {
            console.error("Add Service Error:", error);
            toast.error("Add Service Failed");
        } finally {
            setTimeout(() => {
                setShowLoader(false);
            }, 2000);
        }
    };


    useEffect(() => {
        // stores = array of store objects you already load for dropdown
        if (stores && stores.length === 1) {
            const onlyStore = stores[0]._id;
            setSelectedStoreId(onlyStore);
            console.log("✔ Auto-selected store because only one store exists:", onlyStore);
        }
    }, [stores]);

    const handleBulkUploadClick = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        try {
            const token = localStorage.getItem("Token");
            const userId = localStorage.getItem("userId");

            // Priority: Use the store selected in the dropdown for Admins, or global context for others.
            const sid = (role === "SuperAdmin" || role === "SelfAdmin")
                ? store?.value
                : (Array.isArray(selectedStoreId) ? selectedStoreId[0] : selectedStoreId);

            const storeIdToUse =
                sid ||
                (stores?.length === 1 ? stores[0]._id : null);

            if (!storeIdToUse) {
                alert("Please select a store before uploading services");
                return;
            }

            const formData = new FormData();
            formData.append("file", file);

            // ✅ DROPDOWN STORE FOR ALL SERVICES
            formData.append("storeIds", storeIdToUse);

            console.log("✅ Service Bulk Upload - Selected Store:", storeIdToUse);

            const response = await postData(
                `/services/bulkupload/${userId}`,
                formData,
                token,
                true
            );

            if (response?.success === false) {
                alert(response.message || "Bulk Upload Failed!");
                return;
            }

            alert("Bulk Upload Successful!");
            console.log("Upload Response:", response);
            navigate("/services");
            triggerRefresh();

        } catch (error) {
            console.error("Bulk Upload Failed:", error);
            alert(error?.response?.data?.message || "Error uploading services!");
        }
    };

    const handleViewservice = async (serviceId) => {
        try {
            setLoading(true);

            // Assuming sessionToken is from localStorage
            const sessionToken = localStorage.getItem("Token");

            // Fetch data using your getData function
            const response = await getData(`services/service/${serviceId}`, sessionToken);

            // Check if response is already JSON
            const data = response?.data || response;

            // Set the view data
            setViewServiceData(data);
            setOpenViewPopup(true);
        } catch (error) {
            console.error("Error fetching Service:", error);
            toast.error(error.message || "Failed to fetch Service data");
        } finally {
            setLoading(false);
        }
    };

    // Debounce search query input to avoid frequent API calls
    useEffect(() => {
        const timer = setTimeout(() => {
            setSearchQuery(searchInput);
            setCurrentPage(1);
        }, 350);
        return () => clearTimeout(timer);
    }, [searchInput]);

    const effectiveStoreId = (role === "SuperAdmin" || role === "SelfAdmin")
        ? (store?.value || "")
        : (Array.isArray(selectedStoreId) ? (selectedStoreId[0] || "") : (selectedStoreId || ""));

    useEffect(() => {
        let isCancelled = false;

        const loadServices = async () => {
            const params = {
                page: currentPage,
                limit,
                serviceName: searchQuery?.trim() || "",
                sort: JSON.stringify([[sortField, sortOrder]])
            };
            if (effectiveStoreId && effectiveStoreId !== "ALL" && effectiveStoreId.length === 24) {
                params.storeId = effectiveStoreId;
            }

            try {
                setLoading(true);
                const response = await getData('services/services', params, sessionToken);
                if (isCancelled) return;

                if (response?.status !== 200) {
                    toast.error(response?.message || "Failed to fetch services");
                    return;
                }
                const resultsWrapper = response?.data?.[0];
                const servicesList = resultsWrapper?.paginatedResults || [];
                const totalItems = resultsWrapper?.totalCount || 0;
                const pages = resultsWrapper?.totalPages || 1;

                setServices(servicesList);
                setTotalCount(totalItems);
                setTotalPages(pages);
            } catch (error) {
                if (isCancelled) return;
                toast.error(error.message || "Failed to fetch services");
            } finally {
                if (!isCancelled) {
                    setLoading(false);
                }
            }
        };

        loadServices();

        return () => {
            isCancelled = true;
        };
    }, [currentPage, limit, refreshKey, searchQuery, effectiveStoreId, sortField, sortOrder]);

    const fetchServices = async (page = currentPage, queryLimit = limit, query = searchQuery) => {
        const params = {
            page,
            limit: queryLimit,
            serviceName: query?.trim() || "",
            sort: JSON.stringify([[sortField, sortOrder]])
        };
        if (effectiveStoreId && effectiveStoreId !== "ALL" && effectiveStoreId.length === 24) {
            params.storeId = effectiveStoreId;
        }
        try {
            setLoading(true);
            const response = await getData('services/services', params, sessionToken);
            if (response?.status !== 200) {
                toast.error(response?.message || "Failed to fetch services");
                return;
            }
            const resultsWrapper = response?.data?.[0];
            const servicesList = resultsWrapper?.paginatedResults || [];
            const totalItems = resultsWrapper?.totalCount || 0;
            const pages = resultsWrapper?.totalPages || 1;

            setServices(servicesList);
            setTotalCount(totalItems);
            setTotalPages(pages);
        } catch (error) {
            toast.error(error.message || "Failed to fetch services");
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteService = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem('Token');
            const response = await deleteData(`services/service/${servicesToDelete}`, token);
            toast.success(response?.message || "Service deleted successfully");
            setServices(prev => prev.filter(s => s._id !== servicesToDelete));
            setServicesToDelete(null);
            handleClose();
            fetchServices(currentPage, limit, searchQuery, token);
            triggerRefresh();
        } catch (error) {
            console.error("Delete error:", error);
            toast.error(error?.message || "Failed to delete Service");
        }
    }

    const handleUpdateService = async (e) => {
        e.preventDefault();

        const validationErrors = validateFields(formData, uploadMethod, serviceImage, selectedStockImage);
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        setErrors({});

        setShowLoader(true);

        try {
            const token = localStorage.getItem("Token");
            const userId = localStorage.getItem("userId");

            let updatedImageObject = null;
            if (uploadMethod === "Normal") {
                if (serviceImage && userId) {
                    const uploadResult = await uploadFile(`files/upload/${userId}`, serviceImage);
                    if (uploadResult?.status === 200 || uploadResult?.success) {
                        updatedImageObject = uploadResult.data;
                    } else {
                        toast.error(uploadResult?.message || "Image upload failed");
                        setShowLoader(false);
                        return;
                    }
                } else {
                    updatedImageObject = formData.serviceImageObject;
                }
            } else {
                updatedImageObject = selectedStockImage;
            }

            const isAct = formData.serviceStatus === "Active";
            // 🔥 UPDATED SERVICE PAYLOAD
            const updatedServiceData = {
                storeId: formData.storeId,
                serviceName: formData.serviceName,
                serviceImageObject: updatedImageObject,
                serviceCategory: formData.serviceCategoryId,
                serviceSubCategory: formData.serviceSubCategoryId,
                serviceStatus: formData.serviceStatus,
                isActive: isAct,
                duration: Number(formData.duration),
                gstPercentage: Number(formData.gstPercentage || 0),
                gstAmount: Number(formData.gstAmount || 0),
                basePrice: Number(formData.basePrice || 0),
                nonMemberShipPrice: Number(formData.nonMemberShipPrice || 0),
                memberShipPrice: Number(formData.memberShipPrice || 0),
                description: formData.description || "",
                imageSource: uploadMethod
            };

            console.log("Updating Service with data:", updatedServiceData);

            const response = await putData(
                `services/service/${editServiceId}`,
                updatedServiceData,
                token
            );

            toast.success(response.message || "Service updated successfully");

            const updatedDoc = response?.data;
            setServices(prev => prev.map(s => {
                if (s._id === editServiceId) {
                    const finalIsActive = updatedDoc?.isActive !== undefined 
                        ? updatedDoc.isActive === true 
                        : (updatedDoc?.serviceStatus ? updatedDoc.serviceStatus === "Active" : isAct);
                    const finalStatus = updatedDoc?.serviceStatus || (finalIsActive ? "Active" : "Inactive");
                    return {
                        ...s,
                        ...(updatedDoc || updatedServiceData),
                        isActive: finalIsActive,
                        serviceStatus: finalStatus
                    };
                }
                return s;
            }));

            // ✅ Reset form
            setFormData(prev => ({
                ...prev,
                serviceName: "",
                serviceCategory: "",
                serviceCategoryId: "",
                serviceCategoryName: "",
                serviceSubCategoryId: "",
                serviceSubCategoryName: "",
                serviceStatus: "",
                duration: "",
                gstPercentage: "",
                basePrice: "",
                nonMemberShipPrice: "",
                serviceImageObject: "",
                memberShipPrice: "",
                description: "",
            }));

            setServiceImage(null);
            setPreviewUrl(null);
            setIsPopupMode(false);
            setIsEditMode(false);

            fetchServices(currentPage, limit);
            triggerRefresh();

        } catch (error) {
            console.error("Update Service Error:", error);
            toast.error("Error updating service.");
        } finally {
            setTimeout(() => {
                setShowLoader(false);
            }, 2000);
        }
    };

    useEffect(() => {
        const fetchStores = async () => {
            try {
                const token = localStorage.getItem("Token");
                const data = await getData('stores/stores', {}, token);
                console.log('API Full Response:', data);
                const results = data?.data?.results || [];
                setStores(results);

            } catch (error) {
                console.error("Failed to load stores", error);
            }
        };
        fetchStores();
    }, []);

    useEffect(() => {
        const storedStoreId = localStorage.getItem("storeId");
        if (storedStoreId && stores.length > 0) {
            const matchedStore = stores.find((store) => store._id === storedStoreId);
            if (matchedStore) {
                setFormData((prev) => ({
                    ...prev,
                    storeId: matchedStore._id,
                    storeName: matchedStore.storeName,
                }));
            }
        }
    }, [stores]);

    const triggerRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };

    const handleOpen = (serviceId) => {
        setServicesToDelete(serviceId);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setServicesToDelete(null);
    };

    const handlePageChange = (direction) => {
        setCurrentPage((prev) => {
            if (direction === "next") return Math.min(prev + 1, totalPages);
            if (direction === "prev") return Math.max(prev - 1, 1);
            if (direction === "first") return 1;
            if (direction === "last") return totalPages;
            return prev;
        });
    };

    const handleItemsPerPageChange = (e) => {
        const newLimit = parseInt(e.target.value, 10) || 5;
        setLimit(newLimit);
        setCurrentPage(1);
    };

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: '#F7EAE2',
        borderRadius: 12,
        boxShadow: 24,
        p: 4,
        border: 0
    };

    useEffect(() => {
        const handleStoreChange = () => {
            const storeId = selectedStoreId;
            setSelectedStoreId(storeId);
            setCurrentPage(1);
        };
        window.addEventListener("storeChanged", handleStoreChange);
        return () => window.removeEventListener("storeChanged", handleStoreChange);
    }, []);

    const handleExportExcel = async () => {
        const token = localStorage.getItem("Token");
        const sid = (role === "SuperAdmin" || role === "SelfAdmin")
            ? store?.value
            : (Array.isArray(selectedStoreId) ? selectedStoreId[0] : selectedStoreId);

        const storeIdToUse =
            sid ||
            (stores?.length === 1 ? stores[0]._id : null);

        if (!storeIdToUse) {
            alert("Please select a store before downloading the sample template");
            return;
        }

        try {
            const baseUrl = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
            const response = await fetch(`${baseUrl}/services/sample-template/${storeIdToUse}`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });

            if (!response.ok) {
                throw new Error("Failed to download template");
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "Services.xlsx";
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Failed to generate sample template:", error);
            alert("Failed to generate sample template. Please try again.");
        }
    };

    const handleExportExcelServiceData = async () => {
        try {
            setShowLoader(true);
            setLoaderText("Preparing Excel Export...");
            const params = {
                page: 1,
                limit: "all",
                serviceName: searchQuery?.trim() || "",
                sort: JSON.stringify([[sortField, sortOrder]])
            };
            if (effectiveStoreId && effectiveStoreId !== "ALL" && effectiveStoreId.length === 24) {
                params.storeId = effectiveStoreId;
            }

            const response = await getData('services/services', params, sessionToken);
            const exportList = response?.data?.[0]?.paginatedResults || [];

            if (!exportList || exportList.length === 0) {
                toast.error("No data available to export");
                return;
            }

            // Map data to show names instead of IDs
            const exportData = exportList.map(service => ({
                "Service Name": service.serviceName,
                "Price": service.nonMemberShipPrice,
                "Membership Price": service.memberShipPrice,
                "Time Duration": service.duration,
                "Status": service.serviceStatus,
                "Service Category": service.serviceCategoryDetails?.serviceCategoryName || service.serviceCategory || "",
                "Store Name": service.storeDetails?.[0]?.storeName || "",
            }));

            // Convert to worksheet
            const worksheet = XLSX.utils.json_to_sheet(exportData);

            // Create workbook
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Services");

            // Convert to Excel buffer
            const excelBuffer = XLSX.write(workbook, {
                bookType: "xlsx",
                type: "array"
            });

            // Create Blob
            const data = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });

            saveAs(data, `services-${Date.now()}.xlsx`);
            toast.success("Services exported successfully");
        } catch (error) {
            console.error("Failed to export services:", error);
            toast.error("Failed to export services");
        } finally {
            setShowLoader(false);
        }
    };



    const validateFields = (data, method, serviceImage, stockImg) => {
        let newErrors = {};

        if (!data.storeId) newErrors.storeId = "Store is required";



        if (method === "Normal" && serviceImage) {
            const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
            const allowedExtensions = ["jpg", "jpeg", "png"];
            const fileExtension = serviceImage.name.split('.').pop().toLowerCase();
            const isValidType = allowedTypes.includes(serviceImage.type) || allowedExtensions.includes(fileExtension);
            if (!isValidType) {
                newErrors.serviceImage = "Only JPEG, JPG, and PNG images are allowed.";
            } else if (serviceImage.size > 1024 * 1024) {
                newErrors.serviceImage = "Image size exceeds 1MB. Please select an image smaller than 1MB.";
            }
        }

        if (!data.serviceName) newErrors.serviceName = "Service Name is required";
        if (!data.serviceCategoryId) newErrors.serviceCategoryId = "Service Category is required";
        if (!data.serviceSubCategoryId) newErrors.serviceSubCategoryId = "Service SubCategory is required";

        if (!data.duration) newErrors.duration = "Duration is required";
        if (isGSTVerified && (data.gstPercentage === "" || data.gstPercentage === null)) {
            newErrors.gstPercentage = "GST Percentage is required";
        }
        if (!data.serviceStatus) newErrors.serviceStatus = "Service Status is required";

        if (!data.nonMemberShipPrice) newErrors.nonMemberShipPrice = "Regular Price is required";

        return newErrors;
    };


    const handleEditService = async (service) => {
        try {
            setShowLoader(true);
            setLoaderText("Fetching Service Details...");

            // Fetch latest details to ensure we have populated fields
            const token = localStorage.getItem("Token");
            const response = await getData(`services/service/${service._id}`, token);
            const serviceDetails = response?.data || response;

            if (!serviceDetails) {
                toast.error("Failed to fetch service details");
                setShowLoader(false);
                return;
            }

            const s = serviceDetails;

            setFormData({
                serviceName: s.serviceName,
                serviceCode: s.serviceCode,
                serviceType: s.serviceType,
                serviceImageObject: s.serviceImageObject,
                serviceCategory: s.serviceCategory?._id || s.serviceCategory || "",
                serviceStatus: s.serviceStatus,
                gstPercentage: s.gstPercentage,
                gstAmount: s.gstAmount,
                duration: s.duration,
                nonMemberShipPrice: s.nonMemberShipPrice,
                memberShipPrice: s.memberShipPrice,
                description: s.description || "",

                storeId: s.storeId?._id || s.storeId || "",
                // Find store name from loaded stores or original service object if storeId is just a string
                storeName: s.storeId?.storeName || s.storeDetails?.[0]?.storeName || service.storeId?.storeName || service.storeDetails?.[0]?.storeName || stores.find(store => store._id === (s.storeId?._id || s.storeId))?.storeName || "",

                serviceCategoryId: s.serviceCategory?._id || s.serviceCategory || "",
                serviceCategoryName: s.serviceCategory?.serviceCategoryName || s.serviceCategoryDetails?.[0]?.serviceCategoryName || "",

                serviceSubCategoryId: s.serviceSubCategory?._id || s.serviceSubCategory || "",
                serviceSubCategoryName: s.serviceSubCategory?.serviceSubCategoryName || s.serviceSubCategoryDetails?.[0]?.serviceSubCategoryName || "",
            });

            const method = s.imageSource === "Stock" ? "Stock" : "Normal";
            setUploadMethod(method);

            if (method === "Stock") {
                setSelectedStockImage(s.serviceImageObject);
                setServiceImage(null);
            } else {
                setServiceImage(null); // don't store object here ❗
                setSelectedStockImage(null);
            }

            const baseUrl = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
            const uri = s.serviceImageObject?.uri || "";

            setPreviewUrl(
                uri ? `${baseUrl}/${uri.replace(/^\/+/, "")}` : "/assets/placeholder.png"
            );

            setServiceImage(null);
            setEditserviceId(s._id);
            setIsPopupMode(true);
            setIsEditMode(true);
            setLoaderText("Updating Service...");

        } catch (error) {
            console.error("Edit Service Error:", error);
            toast.error("Failed to load service details for editing");
        } finally {
            /* Keep loader on if we are transitioning to edit mode, or turn off if error 
               But since we set isPopupMode=true, the popup will show. 
               We can hide the main loader now. 
            */
            setShowLoader(false);
        }
    };

    const calculateGSTAmount = (price, gst) => {
        const base = Number(price || 0);
        const gstPercent = Number(gst || 0);
        return ((base * gstPercent) / 100).toFixed(2);
    };



    return (
        <div className='product-layout'>
            <div className='product-content'>
                {showLoader && (
                    <div className="scissor-overlay">
                        <div className="scissor-loader">
                            <TVFMLoader />
                        </div>
                    </div>
                )}
                <main className='product-main'>
                    {isAddService ? (
                        <div className="add-Product-form">
                            <Typography variant="h6" mb={2}>Add Service</Typography>
                            <form className="Service-form">
                                <div className="Service-form-row">
                                    <div className='Service-form-group'>
                                        <label className="input-label">Store Name</label>
                                        <StoreMultiSelect
                                            value={
                                                formData.storeId
                                                    ? [{
                                                        value: formData.storeId,
                                                        label: formData.storeName
                                                    }]
                                                    : []
                                            }
                                            onChange={(val) => {
                                                // ❌ Prevent clearing if only one store
                                                if (adminStoreIds.length === 1) return;

                                                setFormData(prev => ({
                                                    ...prev,
                                                    storeId: val?.[0]?.value || "",
                                                    storeName: val?.[0]?.label || "",
                                                    serviceCategoryId: "",
                                                    serviceCategoryName: "",
                                                    serviceSubCategoryId: "",
                                                    serviceSubCategoryName: ""
                                                }));
                                                setCategoryRefreshKey(prev => prev + 1);
                                                setSubCategoryRefreshKey(prev => prev + 1);
                                            }}
                                            loadStores={loadStores}
                                            loggedInRole={role}
                                            assignedStoreIds={adminStoreIds}
                                            isDisabled={adminStoreIds.length === 1}   // 🔥 KEY LINE
                                        />
                                        {errors.storeId && <p className="field-error">{errors.storeId}</p>}
                                    </div>
                                    <div className="Service-form-group">
                                        <label className="input-label">Service Image (Max 1MB, JPEG/JPG/PNG only)</label>
                                        <div className="upload-options" style={{ display: 'flex', gap: '20px', marginBottom: '12px' }}>
                                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '500', color: '#525252' }}>
                                                <input
                                                    type="radio"
                                                    name="uploadMethod"
                                                    checked={uploadMethod === "Normal"}
                                                    style={{ accentColor: 'linear-gradient(90deg, #181B23 0%, #1C202B 35%, #1A1E28 65%, #161A22 100%)' }}
                                                    onChange={() => {
                                                        setUploadMethod("Normal");
                                                        setPreviewUrl(serviceImage ? URL.createObjectURL(serviceImage) : null);
                                                    }}
                                                />
                                                Normal Upload
                                            </label>
                                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '500', color: '#525252' }}>
                                                <input
                                                    type="radio"
                                                    name="uploadMethod"
                                                    checked={uploadMethod === "Stock"}
                                                    style={{ accentColor: 'linear-gradient(90deg, #181B23 0%, #1C202B 35%, #1A1E28 65%, #161A22 100%)' }}
                                                    onChange={() => {
                                                        setUploadMethod("Stock");
                                                        if (selectedStockImage) {
                                                            const baseUrl = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
                                                            const uri = selectedStockImage.uri || selectedStockImage.fileObject?.uri || "";
                                                            setPreviewUrl(`${baseUrl}/${uri.replace(/^\/+/, "")}`);
                                                        } else {
                                                            setPreviewUrl(null);
                                                        }
                                                    }}
                                                />
                                                Stock Image
                                            </label>
                                        </div>

                                        {uploadMethod === "Normal" ? (
                                            <input
                                                type="file"
                                                accept=".jpeg,.jpg,.png"
                                                className="Service-input"
                                                onChange={(e) => {
                                                    const file = e.target.files[0];
                                                    if (file) {
                                                        const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
                                                        const allowedExtensions = ["jpg", "jpeg", "png"];
                                                        const fileExtension = file.name.split('.').pop().toLowerCase();
                                                        const isValidType = allowedTypes.includes(file.type) || allowedExtensions.includes(fileExtension);

                                                        if (!isValidType) {
                                                            setErrors(prev => ({ ...prev, serviceImage: "Only JPEG, JPG, and PNG images are allowed." }));
                                                            toast.error("Only JPEG, JPG, and PNG images are allowed.");
                                                            setServiceImage(null);
                                                            setPreviewUrl(null);
                                                            if (e.target) e.target.value = "";
                                                        } else if (file.size > 1024 * 1024) {
                                                            setErrors(prev => ({ ...prev, serviceImage: "Image size exceeds 1MB. Please select an image smaller than 1MB." }));
                                                            toast.error("Image size exceeds 1MB. Please select an image smaller than 1MB.");
                                                            setServiceImage(null);
                                                            setPreviewUrl(null);
                                                            if (e.target) e.target.value = "";
                                                        } else {
                                                            setServiceImage(file);
                                                            setPreviewUrl(URL.createObjectURL(file));
                                                            setErrors(prev => ({ ...prev, serviceImage: null }));
                                                        }
                                                    }
                                                }}
                                            />
                                        ) : (
                                            <div className="stock-picker-trigger">
                                                <button
                                                    type="button"
                                                    className="select-stock-btn"
                                                    onClick={() => setShowStockPicker(true)}
                                                    style={{
                                                        width: '100%',
                                                        padding: '8px 12px',
                                                        background: '#fff',
                                                        border: '1px solid #ccc',
                                                        borderRadius: '6px',
                                                        cursor: 'pointer',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        textAlign: 'left',
                                                        justifyContent: 'flex-start',
                                                        gap: '10px',
                                                        fontSize: '14px',
                                                        color: selectedStockImage ? '#333' : '#888'
                                                    }}
                                                >
                                                    <Icon icon="mdi:image-search" style={{ fontSize: '18px', color: '#64748b' }} />
                                                    {selectedStockImage ? `Selected: ${selectedStockImage.name || 'Stock Image'}` : "Click to select a stock image..."}
                                                </button>
                                            </div>
                                        )}
                                        {errors.serviceImage && <p className="field-error">{errors.serviceImage}</p>}
                                        {previewUrl && (
                                            <div className="image-preview" style={{ marginTop: '12px', display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                                                <div style={{ position: 'relative' }}>
                                                    <img src={previewUrl} alt="Preview" style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)' }} />
                                                    <div
                                                        style={{
                                                            position: 'absolute',
                                                            top: '-8px',
                                                            right: '-8px',
                                                            background: '#ef4444',
                                                            color: 'white',
                                                            borderRadius: '50%',
                                                            width: '20px',
                                                            height: '20px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            cursor: 'pointer',
                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                                            zIndex: 5
                                                        }}
                                                        onClick={handleRemoveImage}
                                                        title="Remove image"
                                                    >
                                                        <Icon icon="mdi:close" style={{ fontSize: '14px' }} />
                                                    </div>
                                                </div>
                                                {uploadMethod === "Stock" && selectedStockImage && (
                                                    <div style={{ paddingTop: '4px' }}>
                                                        <p style={{ fontSize: '13px', fontWeight: '600', color: '#1e293b', margin: '0' }}>Stock Image Selected</p>
                                                        <p style={{ fontSize: '11px', color: '#64748b', margin: '2px 0 0' }}>{selectedStockImage.name}</p>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="Service-form-row">
                                    <div className="Service-form-group">
                                        <label htmlFor="serviceName" className="input-label">
                                            Service Name
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter Service name"
                                            required
                                            className="Service-input"

                                            value={formData.serviceName}
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, serviceName: e.target.value }))
                                            }
                                        />
                                        {errors.serviceName && <p className="field-error">{errors.serviceName}</p>}
                                    </div>
                                    <div className="Service-form-group">
                                        <label className="input-label">Service Category</label>
                                        <ServiceCategorySelect
                                            key={`${formData.storeId}-${categoryRefreshKey}`}
                                            value={selectedCategory}
                                            onChange={(val) => {
                                                setSelectedCategory(val);

                                                setFormData(prev => ({
                                                    ...prev,
                                                    serviceCategoryId: val?.value || "",
                                                    serviceCategoryName: val?.label || "",
                                                    serviceSubCategoryId: "",
                                                    serviceSubCategoryName: ""
                                                }));
                                            }}
                                            loadServiceCategories={loadServiceCategories}
                                            onAddServiceCategory={() => setIsAddCategory(true)}
                                            loggedInRole={role}
                                        />
                                        {errors.serviceCategoryId && <p className="field-error">{errors.serviceCategoryId}</p>}
                                    </div>
                                    <div className="Service-form-group">
                                        <label className="input-label">Service SubCategory</label>
                                        <ServiceSubCategorySelect
                                            key={`${formData.serviceCategoryId}-${subCategoryRefreshKey}`}
                                            value={
                                                formData.serviceSubCategoryId
                                                    ? {
                                                        value: formData.serviceSubCategoryId,
                                                        label: formData.serviceSubCategoryName
                                                    }
                                                    : null
                                            }
                                            onChange={(val) => {
                                                setFormData(prev => ({
                                                    ...prev,
                                                    serviceSubCategoryId: val?.value || "",
                                                    serviceSubCategoryName: val?.label || ""
                                                }));
                                            }}
                                            loadServiceSubCategories={loadServiceSubCategories}
                                            onAddServiceSubCategory={() => setIsAddSubCategory(true)}
                                            serviceCategoryId={formData.serviceCategoryId}
                                            isDisabled={!formData.serviceCategoryId}
                                        />
                                        {errors.serviceSubCategoryId && <p className="field-error">{errors.serviceSubCategoryId}</p>}
                                    </div>
                                </div>
                                <div className="Service-form-row">
                                    <div className="Service-form-group">
                                        <label className="input-label">Regular Price</label>
                                        <input
                                            type="text"
                                            className="category-input"
                                            required
                                            value={formData.nonMemberShipPrice || ""}
                                            placeholder="Enter final price"
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (/^\d*\.?\d{0,2}$/.test(value)) {
                                                    const price = Number(value);
                                                    const gstPercentage = Number(formData.gstPercentage || 0);
                                                    const gstAmount = calculateGSTAmount(price, gstPercentage);
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        nonMemberShipPrice: value,
                                                        gstAmount
                                                    }));
                                                }
                                            }}
                                        />
                                        {errors.nonMemberShipPrice && (
                                            <p className="field-error">{errors.nonMemberShipPrice}</p>
                                        )}
                                    </div>
                                    <div className='Service-form-group'>
                                        <label className="input-label">MemberShip Price</label>
                                        <input
                                            type="text"
                                            className="category-input"
                                            value={formData.memberShipPrice || ""}
                                            placeholder="Enter base price"
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (/^\d*\.?\d{0,2}$/.test(value)) {
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        memberShipPrice: value
                                                    }));
                                                }
                                            }}
                                        />
                                    </div>
                                    {/* 🔹 GST % */}
                                    <div className="Service-form-group">
                                        <label className="input-label">GST Percentage</label>
                                        <select
                                            className="category-input"
                                            value={String(formData.gstPercentage ?? "")}
                                            disabled={!isGSTVerified}
                                            onChange={(e) => {
                                                const gstPercentage = Number(e.target.value);
                                                const price = Number(formData.nonMemberShipPrice || 0);
                                                const gstAmount = calculateGSTAmount(
                                                    price,
                                                    gstPercentage
                                                );

                                                setFormData(prev => ({
                                                    ...prev,
                                                    gstPercentage,
                                                    gstAmount
                                                }));
                                            }}
                                        >
                                            <option value="">Select GST</option>
                                            <option value="0">0%</option>
                                            <option value="5">5%</option>
                                            <option value="12">12%</option>
                                            <option value="18">18%</option>
                                        </select>
                                        {errors.gstPercentage && <p className="field-error">{errors.gstPercentage}</p>}
                                    </div>

                                    <div className="Service-form-group">
                                        <label className="input-label">GST Amount</label>
                                        <input
                                            type="text"
                                            className="category-input"
                                            readOnly
                                            value={formData.gstAmount || "0.00"}
                                        />
                                    </div>

                                    {/* 🔹 FINAL PRICE (FREE TEXT) */}
                                </div>

                                <div className="Service-form-row">
                                    <div className="Service-form-group">
                                        <label className="input-label">Time Duration (in minutes)</label>
                                        <input
                                            type="number"
                                            className="category-input"
                                            required
                                            value={formData.duration || ""}
                                            onChange={(e) =>
                                                setFormData(prev => ({ ...prev, duration: e.target.value }))
                                            }
                                        />
                                        {errors.duration && <p className="field-error">{errors.duration}</p>}
                                    </div>
                                    <div className="Service-form-group">
                                        <label className="input-label">Service Status</label>
                                        <select
                                            id="serviceStatus"
                                            className="category-input"
                                            required
                                            disabled={!formData.duration}
                                            value={formData.serviceStatus}
                                            onChange={(e) => {
                                                const selectedServiceStatus = e.target.value;
                                                setFormData((prev) => ({ ...prev, serviceStatus: selectedServiceStatus }))
                                            }}
                                        >
                                            <option value='' >Select Service Status</option>
                                            <option value='Active'>Active</option>
                                            <option value='Inactive'>Inactive</option>
                                        </select>
                                        {errors.serviceStatus && <p className="field-error">{errors.serviceStatus}</p>}
                                    </div>

                                </div>
                                <div className="Service-form-row">
                                    <div className="Service-form-group" style={{ flex: "1 1 100%" }}>
                                        <label htmlFor="description" className="input-label">Description</label>
                                        <textarea
                                            id="description"
                                            placeholder="Enter service description. You can type paragraphs, and use bullet points (e.g., - item) or numbered lists."
                                            className="category-input"
                                            style={{ minHeight: "100px", padding: "10px", width: "100%", resize: "vertical", fontFamily: "inherit" }}
                                            value={formData.description || ""}
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, description: e.target.value }))
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="Service-buttons">
                                    <button className="add-Product-button" type="submit" onClick={handleAddService}>
                                        Add Service
                                    </button>
                                    <button className="cancel-Product-button" onClick={() => navigate('/services')}>
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    ) : (
                        <>
                            <Typography variant="h6" gutterBottom>
                                Services
                            </Typography>
                            <div className="product-widgets">
                                <div className="product-widgets-left">
                                    <div className="search-input-wrapper">
                                        <input
                                            type="text"
                                            placeholder="Search services..."
                                            className="service-search-input"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                        />
                                        <Icon icon="mdi:magnify" className="search-icon" />
                                    </div>
                                    {(role === "SuperAdmin" || role === "SelfAdmin") && (
                                        <StoreSingleAllStoresSelect
                                            value={store}
                                            onChange={(val) => {
                                                setStore(val);
                                                setSelectedStoreId(val?.value || "");
                                                setCurrentPage(1);
                                            }}
                                        />
                                    )}
                                </div>
                                <div className="add-product-buttons desktop-only">
                                    <button className="add-btn-product" onClick={handleExportExcelServiceData}>Export</button>
                                    <button
                                        className="add-btn-product"
                                        onClick={() => fileInputRef.current.click()}
                                    >
                                        Import
                                    </button>
                                    <button className="add-btn-product" onClick={() => navigate('/services/add')}>+ Add Service</button>
                                    <button className="add-btn-product" onClick={handleExportExcel}>Download Sample Template</button>
                                </div>

                                <div className="add-product-buttons mobile-only">
                                    <button className="add-btn-product" onClick={() => navigate('/services/add')}>+ Add Service</button>
                                    
                                    <button 
                                        className="add-btn-product dropdown-trigger" 
                                        onClick={handleActionClick}
                                        style={{ 
                                            background: '#f8fafc', 
                                            color: '#3C0008', 
                                            border: '1px solid #3C0008',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '4px'
                                        }}
                                    >
                                        <Icon icon="mdi:tune" width="18" /> Actions
                                    </button>

                                    <Menu
                                        anchorEl={actionAnchorEl}
                                        open={isActionMenuOpen}
                                        onClose={handleActionClose}
                                        PaperProps={{
                                            sx: {
                                                borderRadius: '12px',
                                                mt: 1,
                                                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                                                border: '1px solid #e2e8f0',
                                                '& .MuiMenuItem-root': {
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '10px'
                                                }
                                            }
                                        }}
                                    >
                                        <MenuItem 
                                            onClick={() => {
                                                handleActionClose();
                                                handleExportExcelServiceData();
                                            }}
                                            sx={{ fontSize: '14px', fontWeight: 500, color: '#334155', px: 2, py: 1.2 }}
                                        >
                                            <Icon icon="mdi:export" style={{ fontSize: '18px', color: '#64748b' }} />
                                            Export
                                        </MenuItem>
                                        <MenuItem 
                                            onClick={() => {
                                                handleActionClose();
                                                fileInputRef.current.click();
                                            }}
                                            sx={{ fontSize: '14px', fontWeight: 500, color: '#334155', px: 2, py: 1.2 }}
                                        >
                                            <Icon icon="mdi:import" style={{ fontSize: '18px', color: '#64748b' }} />
                                            Import
                                        </MenuItem>
                                        <MenuItem 
                                            onClick={() => {
                                                handleActionClose();
                                                handleExportExcel();
                                            }}
                                            sx={{ fontSize: '14px', fontWeight: 500, color: '#334155', px: 2, py: 1.2 }}
                                        >
                                            <Icon icon="mdi:download" style={{ fontSize: '18px', color: '#64748b' }} />
                                            Download Sample Template
                                        </MenuItem>
                                    </Menu>
                                </div>
                                <input
                                    type="file"
                                    accept=".xlsx, .xls"
                                    style={{ display: "none" }}
                                    ref={fileInputRef}
                                    onChange={handleBulkUploadClick}
                                />
                            </div>
                            <Box component={Paper}>
                                <TableContainer component={Paper} sx={{
                                    maxHeight: 400,
                                    overflowY: "auto",
                                    '&::-webkit-scrollbar': { display: 'none' },
                                    scrollbarWidth: 'none',
                                    msOverflowStyle: 'none',
                                    boxShadow: "none",
                                }}>
                                    <Table className="custom-service-table">
                                        <TableHead className="custom-product-head">
                                            <TableRow>
                                                {headings.map((heading, index) => {
                                                    const isServiceName = heading === "Name";
                                                    const isLocation = heading === "Location";
                                                    const isPrice = heading === "Price";
                                                    const sortKey = isServiceName
                                                        ? "serviceName"
                                                        : isLocation
                                                            ? "storeId"
                                                            : isPrice
                                                                ? "nonMemberShipPrice"
                                                                : null

                                                    return (
                                                        <TableCell
                                                            key={index}
                                                            sx={{
                                                                border: "none",
                                                                padding: "12px 16px",
                                                                textAlign: "center",
                                                                position: "sticky",
                                                                top: 0,
                                                                zIndex: 10,
                                                                backgroundColor: "#3C0008",
                                                            }}
                                                        >
                                                            <Typography
                                                                variant="body2"
                                                                sx={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    gap: "4px",
                                                                    color: "#ffffff",
                                                                    fontSize: "14px",
                                                                    fontWeight: 600,
                                                                }}
                                                            >
                                                                {heading}

                                                                {sortKey && (
                                                                    <span
                                                                        onClick={() => handleSort(sortKey)}
                                                                        style={{
                                                                            fontSize: "10px",
                                                                            color: "#ffffffff",
                                                                            cursor: "pointer",
                                                                            marginLeft: "4px",
                                                                            userSelect: "none",
                                                                        }}
                                                                    >
                                                                        {sortField === sortKey
                                                                            ? sortOrder === 1
                                                                                ? "▲"
                                                                                : "▼"
                                                                            : "▲▼"}
                                                                    </span>
                                                                )}
                                                            </Typography>
                                                        </TableCell>
                                                    );
                                                })}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {services.length === 0 ? (
                                                <TableRow>
                                                    <TableCell colSpan={5}>
                                                        <Typography sx={{ textAlign: 'center', padding: '20px', fontWeight: 500 }}>
                                                            No services found.
                                                        </Typography>
                                                    </TableCell>
                                                </TableRow>
                                            ) : (
                                                services.map((service, index) => (
                                                    <TableRow key={service._id}>
                                                        <TableCell>
                                                            <Typography sx={commonCellStyle}>
                                                                {(currentPage - 1) * (limit === 'all' ? 0 : limit) + index + 1}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                                                <img
                                                                    src={service.serviceImageObject?.uri ? `${(process.env.REACT_APP_API_URL || "").replace(/\/+$/, "")}/${service.serviceImageObject.uri.replace(/^\/+/, "")}` : "/assets/placeholder.png"}
                                                                    alt={service.serviceName}
                                                                    onError={(e) => { e.target.onerror = null; e.target.src = "/assets/placeholder.png"; }}
                                                                    style={{ width: '50px', height: '50px', borderRadius: '8px', objectFit: 'cover' }}
                                                                />
                                                            </Box>
                                                        </TableCell>
                                                        <TableCell><Typography sx={commonCellStyle}>{service.serviceName}</Typography></TableCell>
                                                        <TableCell><Typography sx={commonCellStyle}>{service.storeDetails?.[0]?.storeName}</Typography></TableCell>
                                                        <TableCell><Typography sx={commonCellStyle}>₹{service.nonMemberShipPrice}</Typography></TableCell>
                                                        <TableCell>
                                                            {(() => {
                                                                const isActiveStatus = service.isActive !== undefined ? service.isActive === true : service.serviceStatus === 'Active';
                                                                return (
                                                                    <Button
                                                                        variant="contained"
                                                                        sx={{
                                                                            backgroundColor: isActiveStatus ? '#3C0008' : '#f5dfdf',
                                                                            color: isActiveStatus ? '#ffffff' : '#C10000',
                                                                            fontWeight: 500,
                                                                            padding: '4px 8px',
                                                                            borderRadius: '20px',
                                                                            width: '90px',
                                                                            maxHeight: '70px',
                                                                            fontSize: '12px',
                                                                            textTransform: 'none',
                                                                            '&:hover': {
                                                                                backgroundColor: isActiveStatus ? '#58000c' : '#f5c6c6',
                                                                                boxShadow: 'none',
                                                                            },
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                            margin: '0 auto',
                                                                            boxShadow: 'none',
                                                                        }}
                                                                    >
                                                                        {isActiveStatus ? 'Active' : 'Inactive'}
                                                                    </Button>
                                                                );
                                                            })()}
                                                        </TableCell>
                                                        <TableCell>
                                                            <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', justifyContent: 'center' }}>
                                                                <Tooltip title="View Service">
                                                                    <Icon icon={plusIcon} width={20} height={20} style={{ cursor: "pointer" }} onClick={() => handleViewservice(service._id)} />
                                                                </Tooltip>
                                                                <Tooltip title="Edit Service">
                                                                    <Icon
                                                                        icon={editIcon}
                                                                        width={20}
                                                                        height={20}
                                                                        style={{ cursor: "pointer" }}
                                                                        onClick={() => handleEditService(service)}
                                                                    />
                                                                </Tooltip>
                                                                {role !== "SelfAdmin" && (
                                                                    <Tooltip title="Delete Service">
                                                                        <Icon icon={deleteIcon} width={20} height={20} style={{ color: '#C10000', cursor: "pointer" }}
                                                                            onClick={() => handleOpen(service._id)}
                                                                        />
                                                                    </Tooltip>
                                                                )}
                                                            </Box>
                                                        </TableCell>
                                                    </TableRow>

                                                ))
                                            )}

                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <div className="product-bottom">
                                    <div className="service-section show-entries">
                                        <span className="text-label">Show</span>
                                        <select className="entries-select" value={limit}
                                            onChange={handleItemsPerPageChange}
                                        >
                                            <option value={5}>5</option>
                                            <option value={10}>10</option>
                                            <option value={25}>25</option>
                                            <option value={50}>50</option>
                                            <option value={100}>100</option>
                                        </select>
                                        <span className="text-label">Entries</span>
                                    </div>
                                    <div className="service-section showing-range">
                                        {
                                            totalCount === 0
                                                ? "Showing 0 entries"
                                                : `Showing ${(currentPage - 1) * limit + 1} to ${Math.min(currentPage * limit, totalCount)} of ${totalCount} entries`
                                        }
                                    </div>
                                    <div className="service-section spacer"></div>
                                    <div className="service-section pagination-buttons">
                                        <button
                                            className="pagination-btn"
                                            disabled={currentPage === 1}
                                            onClick={() => handlePageChange("first")}
                                        ><Icon icon="mdi:chevron-double-left" /></button>
                                        <button
                                            className="pagination-btn"
                                            disabled={currentPage === 1}
                                            onClick={() => handlePageChange("prev")}
                                        ><Icon icon="mdi:chevron-left" /></button>
                                        <button
                                            className="pagination-btn"
                                            disabled={currentPage === totalPages}
                                            onClick={() => handlePageChange("next")}
                                        ><Icon icon="mdi:chevron-right" /></button>
                                        <button
                                            className="pagination-btn"
                                            disabled={currentPage === totalPages}
                                            onClick={() => handlePageChange("last")}
                                        ><Icon icon="mdi:chevron-double-right" /></button>
                                    </div>
                                </div>
                            </Box>
                            {isPopupMode && (
                                <div className="popup-overlay">
                                    <div className="popup-wrapper">
                                        <Icon
                                            icon={closeIcon}
                                            className="popup-close-icon-outside"
                                            onClick={() => {
                                                setIsPopupMode(false);
                                                setIsEditMode(false);
                                                setFormData(prev => ({
                                                    ...prev,
                                                    serviceName: '',
                                                    serviceCode: '',
                                                    serviceType: '',
                                                    serviceImageObject: '',
                                                    serviceCategory: '',
                                                    serviceStatus: '',
                                                    gstPercentage: '',
                                                    duration: '',
                                                    nonMemberShipPrice: '',
                                                    memberShipPrice: '',
                                                    description: '',
                                                }));
                                                setPreviewUrl(null);
                                                setLoaderText("");
                                            }}
                                        />
                                        <div className="popup-form">
                                            <Typography
                                                variant="h6"
                                                textAlign="center"
                                                mb={4}
                                            >
                                                {isEditMode ? "Edit Service" : "Add Service"}
                                            </Typography>
                                            <form
                                                className="popup-form-body"
                                                onSubmit={isEditMode ? handleUpdateService : handleAddService}
                                            >
                                                {/* Branch & Image */}
                                                <div className="form-group-row">
                                                    {/* Select Store */}
                                                    <div className="form-group">
                                                        <label className="input-label">Store Name</label>
                                                        <StoreMultiSelect
                                                            value={formData.storeId ? [{ value: formData.storeId, label: formData.storeName }] : []}
                                                            onChange={(val) => {
                                                                const storeId = val && val.length > 0 ? (Array.isArray(val) ? val[0].value : val.value) : "";
                                                                const storeName = val && val.length > 0 ? (Array.isArray(val) ? val[0].label : val.label) : "";
                                                                setFormData(prev => ({
                                                                    ...prev,
                                                                    storeId: storeId,
                                                                    storeName: storeName,
                                                                    serviceCategoryId: "",
                                                                    serviceCategoryName: "",
                                                                    serviceSubCategoryId: "",
                                                                    serviceSubCategoryName: ""
                                                                }));
                                                                setCategoryRefreshKey(prev => prev + 1);
                                                                setSubCategoryRefreshKey(prev => prev + 1);
                                                            }}
                                                            loadStores={loadStores}
                                                            loggedInRole={role}
                                                            assignedStoreIds={adminStoreIds}
                                                            isMulti={false}
                                                            isDisabled={(role === "StoreAdmin" || role === "StoreManager") && adminStoreIds.length === 1}
                                                            onAddStore={() => setIsAddStore(true)}
                                                        />
                                                        {errors.storeId && <p className="field-error">{errors.storeId}</p>}
                                                    </div>

                                                    {/* Service Image */}
                                                    <div className="form-group" style={{ gridColumn: 'span 2' }}>
                                                        <label className="input-label">Service Image (Max 1MB, JPEG/JPG/PNG only)</label>
                                                        <div className="upload-options" style={{ display: 'flex', gap: '20px', marginBottom: '12px' }}>
                                                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '500', color: '#525252' }}>
                                                                <input
                                                                    type="radio"
                                                                    name="uploadMethod"
                                                                    checked={uploadMethod === "Normal"}
                                                                    style={{ accentColor: 'linear-gradient(90deg, #181B23 0%, #1C202B 35%, #1A1E28 65%, #161A22 100%)' }}
                                                                    onChange={() => {
                                                                        setUploadMethod("Normal");
                                                                        if (serviceImage) {
                                                                            setPreviewUrl(URL.createObjectURL(serviceImage));
                                                                        } else if (formData.serviceImageObject?.uri) {
                                                                            setPreviewUrl(formData.serviceImageObject?.uri
                                                                                ? `${(process.env.REACT_APP_API_URL || "").replace(/\/+$/, "")}/${formData.serviceImageObject.uri.replace(/^\/+/, "")}`
                                                                                : null);
                                                                        } else {
                                                                            setPreviewUrl(null);
                                                                        }
                                                                    }}
                                                                />
                                                                Normal Upload
                                                            </label>
                                                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '500', color: '#525252' }}>
                                                                <input
                                                                    type="radio"
                                                                    name="uploadMethod"
                                                                    checked={uploadMethod === "Stock"}
                                                                    style={{ accentColor: 'linear-gradient(90deg, #181B23 0%, #1C202B 35%, #1A1E28 65%, #161A22 100%)' }}
                                                                    onChange={() => {
                                                                        setUploadMethod("Stock");
                                                                        if (selectedStockImage) {
                                                                            const baseUrl = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
                                                                            const uri = selectedStockImage.uri || selectedStockImage.fileObject?.uri || "";
                                                                            setPreviewUrl(`${baseUrl}/${uri.replace(/^\/+/, "")}`);
                                                                        } else {
                                                                            setPreviewUrl(null);
                                                                        }
                                                                    }}
                                                                />
                                                                Stock Image
                                                            </label>
                                                        </div>

                                                        {uploadMethod === "Normal" ? (
                                                            <input
                                                                type="file"
                                                                accept=".jpeg,.jpg,.png"
                                                                className="category-input"
                                                                onChange={(e) => {
                                                                    const file = e.target.files[0];
                                                                    if (file) {
                                                                        const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
                                                                        const allowedExtensions = ["jpg", "jpeg", "png"];
                                                                        const fileExtension = file.name.split('.').pop().toLowerCase();
                                                                        const isValidType = allowedTypes.includes(file.type) || allowedExtensions.includes(fileExtension);

                                                                        if (!isValidType) {
                                                                            setErrors(prev => ({ ...prev, serviceImage: "Only JPEG, JPG, and PNG images are allowed." }));
                                                                            toast.error("Only JPEG, JPG, and PNG images are allowed.");
                                                                            setServiceImage(null);
                                                                            setPreviewUrl(null);
                                                                            if (e.target) e.target.value = "";
                                                                        } else if (file.size > 1024 * 1024) {
                                                                            setErrors(prev => ({ ...prev, serviceImage: "Image size exceeds 1MB. Please select an image smaller than 1MB." }));
                                                                            toast.error("Image size exceeds 1MB. Please select an image smaller than 1MB.");
                                                                            setServiceImage(null);
                                                                            setPreviewUrl(null);
                                                                            if (e.target) e.target.value = "";
                                                                        } else {
                                                                            setServiceImage(file);
                                                                            setPreviewUrl(URL.createObjectURL(file));
                                                                            setErrors(prev => ({ ...prev, serviceImage: null }));
                                                                        }
                                                                    }
                                                                }}
                                                            />
                                                        ) : (
                                                            <div className="stock-picker-trigger">
                                                                <button
                                                                    type="button"
                                                                    className="select-stock-btn"
                                                                    onClick={() => setShowStockPicker(true)}
                                                                    style={{
                                                                        width: '100%',
                                                                        padding: '8px 12px',
                                                                        background: '#fff',
                                                                        border: '1px solid #ccc',
                                                                        borderRadius: '6px',
                                                                        cursor: 'pointer',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        textAlign: 'left',
                                                                        justifyContent: 'flex-start',
                                                                        gap: '10px',
                                                                        fontSize: '14px',
                                                                        color: selectedStockImage ? '#333' : '#888'
                                                                    }}
                                                                >
                                                                    <Icon icon="mdi:image-search" style={{ fontSize: '18px', color: '#64748b' }} />
                                                                    {selectedStockImage ? `Selected: ${selectedStockImage.name || 'Stock Image'}` : "Click to select a stock image..."}
                                                                </button>
                                                            </div>
                                                        )}
                                                        {errors.serviceImage && <p className="field-error">{errors.serviceImage}</p>}
                                                        {previewUrl && (
                                                            <div className="image-preview" style={{ marginTop: '12px', display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                                                                <div style={{ position: 'relative' }}>
                                                                    <img src={previewUrl} alt="Preview" style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)' }} />
                                                                    <div
                                                                        style={{
                                                                            position: 'absolute',
                                                                            top: '-8px',
                                                                            right: '-8px',
                                                                            background: '#ef4444',
                                                                            color: 'white',
                                                                            borderRadius: '50%',
                                                                            width: '20px',
                                                                            height: '20px',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                            cursor: 'pointer',
                                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                                                            zIndex: 5
                                                                        }}
                                                                        onClick={handleRemoveImage}
                                                                        title="Remove image"
                                                                    >
                                                                        <Icon icon="mdi:close" style={{ fontSize: '14px' }} />
                                                                    </div>
                                                                </div>
                                                                {uploadMethod === "Stock" && selectedStockImage && (
                                                                    <div style={{ paddingTop: '4px' }}>
                                                                        <p style={{ fontSize: '13px', fontWeight: '600', color: '#1e293b', margin: '0' }}>Stock Image Selected</p>
                                                                        <p style={{ fontSize: '11px', color: '#64748b', margin: '2px 0 0' }}>{selectedStockImage.name}</p>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>


                                                </div>

                                                {/* Category + Non-Member Price + Duration */}
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label className="input-label">Service Name</label>
                                                        <input
                                                            type="text"
                                                            className="Service-input"
                                                            value={formData.serviceName || ""}
                                                            onChange={(e) =>
                                                                setFormData({ ...formData, serviceName: e.target.value })
                                                            }
                                                            required
                                                        />
                                                        {errors.serviceName && <p className="field-error">{errors.serviceName}</p>}
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="input-label">Service Category</label>
                                                        <ServiceCategorySelect
                                                            key={`${formData.storeId}-${categoryRefreshKey}`}
                                                            value={
                                                                formData.serviceCategoryId
                                                                    ? {
                                                                        value: formData.serviceCategoryId,
                                                                        label: formData.serviceCategoryName
                                                                    }
                                                                    : null
                                                            }
                                                            onChange={(val) => {
                                                                setFormData(prev => ({
                                                                    ...prev,
                                                                    serviceCategoryId: val?.value || "",
                                                                    serviceCategoryName: val?.label || "",
                                                                    serviceSubCategoryId: "", // Reset SubCategory
                                                                    serviceSubCategoryName: ""
                                                                }));
                                                                setSubCategoryRefreshKey(prev => prev + 1);
                                                            }}
                                                            loadServiceCategories={loadServiceCategories}
                                                            onAddServiceCategory={() => setIsAddCategory(true)}
                                                            loggedInRole={role}
                                                        />
                                                        {errors.serviceCategoryId && <p className="field-error">{errors.serviceCategoryId}</p>}
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="input-label">Service SubCategory</label>
                                                        <ServiceSubCategorySelect
                                                            key={`${formData.serviceCategoryId}-${subCategoryRefreshKey}`}
                                                            value={
                                                                formData.serviceSubCategoryId
                                                                    ? {
                                                                        value: formData.serviceSubCategoryId,
                                                                        label: formData.serviceSubCategoryName
                                                                    }
                                                                    : null
                                                            }
                                                            onChange={(val) => {
                                                                setFormData(prev => ({
                                                                    ...prev,
                                                                    serviceSubCategoryId: val?.value || "",
                                                                    serviceSubCategoryName: val?.label || ""
                                                                }));
                                                            }}
                                                            loadServiceSubCategories={loadServiceSubCategories}
                                                            onAddServiceSubCategory={() => setIsAddSubCategory(true)}
                                                            serviceCategoryId={formData.serviceCategoryId}
                                                            isDisabled={!formData.serviceCategoryId}
                                                        />
                                                        {errors.serviceSubCategoryId && <p className="field-error">{errors.serviceSubCategoryId}</p>}
                                                    </div>
                                                </div>
                                                <div className="form-group-row">

                                                    <div className="form-group">
                                                        <label className="input-label">Regular Price</label>
                                                        <input
                                                            type="text"
                                                            className="category-input"
                                                            value={formData.nonMemberShipPrice || ""}
                                                            placeholder="Enter final price"
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                if (/^\d*\.?\d{0,2}$/.test(value)) {
                                                                    setFormData(prev => ({
                                                                        ...prev,
                                                                        nonMemberShipPrice: value
                                                                    }));
                                                                }
                                                            }}
                                                        />
                                                        {errors.nonMemberShipPrice && <p className="field-error">{errors.nonMemberShipPrice}</p>}
                                                    </div>
                                                    {/* 🔹 BASE PRICE */}
                                                    <div className="form-group">
                                                        <label className="input-label">MemberShip Price</label>
                                                        <input
                                                            type="text"
                                                            className="category-input"
                                                            value={formData.memberShipPrice || ""}
                                                            placeholder="Enter base price"
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                if (/^\d*\.?\d{0,2}$/.test(value)) {
                                                                    setFormData(prev => ({
                                                                        ...prev,
                                                                        memberShipPrice: value
                                                                    }));
                                                                }
                                                            }}
                                                        />
                                                    </div>

                                                    {/* 🔹 GST % */}
                                                    <div className="form-group">
                                                        <label className="input-label">GST Percentage</label>
                                                        <select
                                                            className="category-input"
                                                            disabled={!isGSTVerified}
                                                            value={String(formData.gstPercentage ?? "")}
                                                            onChange={(e) => {
                                                                const gstPercentage = Number(e.target.value);
                                                                const gstAmount = calculateGSTAmount(
                                                                    formData.nonMemberShipPrice,
                                                                    gstPercentage
                                                                );

                                                                setFormData(prev => ({
                                                                    ...prev,
                                                                    gstPercentage,
                                                                    gstAmount
                                                                }));
                                                            }}
                                                        >
                                                            <option value="">Select GST</option>
                                                            <option value="0">0%</option>
                                                            <option value="5">5%</option>
                                                            <option value="12">12%</option>
                                                            <option value="18">18%</option>
                                                        </select>
                                                        {errors.gstPercentage && <p className="field-error">{errors.gstPercentage}</p>}
                                                    </div>
                                                </div>

                                                <div className="form-group-row">
                                                    {/* 🔹 GST AMOUNT */}
                                                    <div className="form-group">
                                                        <label className="input-label">GST Amount</label>
                                                        <input
                                                            type="text"
                                                            className="category-input"
                                                            readOnly
                                                            value={formData.gstAmount || "0.00"}
                                                        />
                                                    </div>

                                                    <div className="form-group">
                                                        <label className="input-label">Duration (Mins)</label>
                                                        <input
                                                            type="number"
                                                            className="category-input"
                                                            value={formData.duration || ""}
                                                            onChange={(e) =>
                                                                setFormData({
                                                                    ...formData,
                                                                    duration: e.target.value,
                                                                })
                                                            }
                                                        />
                                                        {errors.duration && <p className="field-error">{errors.duration}</p>}
                                                    </div>

                                                    <div className="form-group">
                                                        <label className="input-label">Service Status</label>
                                                        <select
                                                            className="category-input"
                                                            value={formData.serviceStatus}
                                                            onChange={(e) =>
                                                                setFormData({
                                                                    ...formData,
                                                                    serviceStatus: e.target.value,
                                                                })
                                                            }
                                                        >
                                                            <option value="">Select Status</option>
                                                            <option value="Active">Active</option>
                                                            <option value="Inactive">Inactive</option>
                                                        </select>
                                                        {errors.serviceStatus && <p className="field-error">{errors.serviceStatus}</p>}
                                                    </div>


                                                </div>
                                                <div className="form-group-row">
                                                    <div className="form-group" style={{ flex: "1 1 100%" }}>
                                                        <label className="input-label">Description</label>
                                                        <textarea
                                                            placeholder="Enter service description. You can type paragraphs, and use bullet points (e.g., - item) or numbered lists."
                                                            className="category-input"
                                                            style={{ minHeight: "100px", padding: "10px", width: "100%", resize: "vertical", fontFamily: "inherit" }}
                                                            value={formData.description || ""}
                                                            onChange={(e) =>
                                                                setFormData({ ...formData, description: e.target.value })
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-actions">
                                                    <button type="submit" className="add-Product-button">
                                                        {isEditMode ? "Update Service" : "Add Service"}
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="cancel-Product-button"
                                                        onClick={() => setIsPopupMode(false)}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <Modal
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="modal-modal-title"
                            >
                                <Box
                                    sx={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: 380,
                                        background: "linear-gradient(135deg, #ffffff, #faf5f6)",
                                        borderRadius: "20px",
                                        boxShadow: "0 25px 70px rgba(0,0,0,0.35)",
                                        p: 4,
                                        outline: "none",
                                        textAlign: "center",
                                        overflow: "hidden"
                                    }}
                                >
                                    {/* ✅ TOP ICON BADGE */}
                                    <Box
                                        sx={{
                                            width: 74,
                                            height: 74,
                                            borderRadius: "50%",
                                            background: "#3C0008",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            margin: "0 auto 16px auto",
                                            color: "#fff",
                                            fontSize: 30,

                                            boxShadow: "0 12px 28px rgba(26,30,39,0.55)",
                                            animation: "deletePulse 1.6s infinite ease-in-out",

                                            "@keyframes deletePulse": {
                                                "0%": {
                                                    transform: "scale(1)",
                                                    boxShadow: "0 0 0 0 rgba(26,30,39,0.7)",
                                                },
                                                "70%": {
                                                    transform: "scale(1.1)",
                                                    boxShadow: "0 0 0 18px rgba(26,30,39,0)",
                                                },
                                                "100%": {
                                                    transform: "scale(1)",
                                                    boxShadow: "0 0 0 0 rgba(26,30,39,0)",
                                                },
                                            },
                                        }}
                                    >
                                        🗑️
                                    </Box>


                                    {/* ✅ TITLE */}
                                    <Typography
                                        id="modal-modal-title"
                                        variant="h6"
                                        sx={{
                                            fontWeight: 700,
                                            color: "#2b2b2b",
                                            letterSpacing: "0.3px"
                                        }}
                                    >
                                        Confirm Delete
                                    </Typography>

                                    {/* ✅ DESCRIPTION */}
                                    <Typography
                                        id="modal-modal-description"
                                        sx={{
                                            mt: 1.2,
                                            fontSize: 14,
                                            color: "#666",
                                            lineHeight: 1.6
                                        }}
                                    >
                                        Are you sure you want to delete this service?
                                    </Typography>

                                    {/* ✅ BUTTON GROUP */}
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            gap: 2.5,
                                            mt: 3.5
                                        }}
                                    >
                                        {/* ✅ DELETE BUTTON */}
                                        <Button
                                            variant="contained"
                                            onClick={handleDeleteService}
                                            className='add-Product-button'
                                        >
                                            Yes, Delete
                                        </Button>

                                        {/* ✅ CANCEL BUTTON */}
                                        <Button
                                            variant="outlined"
                                            onClick={handleClose}
                                            className='cancel-Product-button'
                                        >
                                            Cancel
                                        </Button>
                                    </Box>
                                </Box>
                            </Modal>
                            {openViewPopup && (
                                <ViewServicePopup
                                    data={viewServiceData}
                                    onClose={() => setOpenViewPopup(false)}
                                />
                            )}
                        </>
                    )
                    }
                    {isAddStore && (
                        <div className="popup-overlay">
                            <div className="popup-wrapper" style={{ maxWidth: '900px', width: '95%' }}>
                                <Icon
                                    icon={closeIcon}
                                    className="popup-close-icon-outside"
                                    onClick={() => setIsAddStore(false)}
                                />
                                <div className="popup-form" style={{ maxHeight: '85vh', overflowY: 'auto', padding: '20px' }}>
                                    <AddStoreForm
                                        onSuccess={() => {
                                            setIsAddStore(false);
                                            // Trigger store reload/refresh if needed
                                            // For now just close, user can re-search
                                        }}
                                        onCancel={() => setIsAddStore(false)}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                    {isAddCategory && (
                        <div className="popup-overlay">
                            <div className="popup-wrapper" style={{ maxWidth: '900px', width: '95%' }}>
                                <Icon icon={closeIcon} className="popup-close-icon-outside" onClick={() => setIsAddCategory(false)} />
                                <div className="popup-form" style={{ maxHeight: '85vh', overflowY: 'auto', padding: '20px' }}>
                                    <AddServiceCategoryForm
                                        initialStoreId={formData.storeId}
                                        onSuccess={(newCategory) => {

                                            const category = newCategory.newServiceCategoryObj;

                                            setSelectedCategory({
                                                value: category._id,
                                                label: category.serviceCategoryName
                                            });

                                            setFormData(prev => ({
                                                ...prev,
                                                serviceCategoryId: category._id,
                                                serviceCategoryName: category.serviceCategoryName,
                                                serviceSubCategoryId: "",
                                                serviceSubCategoryName: ""
                                            }));
                                            setIsAddCategory(false);
                                        }}
                                        onCancel={() => setIsAddCategory(false)}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                    {isAddSubCategory && (
                        <div className="popup-overlay">
                            <div className="popup-wrapper" style={{ maxWidth: '900px', width: '95%' }}>
                                <Icon icon={closeIcon} className="popup-close-icon-outside" onClick={() => setIsAddSubCategory(false)} />
                                <div className="popup-form" style={{ maxHeight: '85vh', overflowY: 'auto', padding: '20px' }}>
                                    <AddServiceSubCategoryForm
                                        initialStoreId={formData.storeId}
                                        initialCategoryId={formData.serviceCategoryId}
                                        initialCategoryName={formData.serviceCategoryName}
                                        onSuccess={(newSubCategory) => {

                                            const subCategory =
                                                newSubCategory.newServiceSubCategoryObj || newSubCategory;

                                            setFormData(prev => ({
                                                ...prev,
                                                serviceSubCategoryId: subCategory._id,
                                                serviceSubCategoryName: subCategory.serviceSubCategoryName
                                            }));

                                            setIsAddSubCategory(false);
                                        }}
                                        onCancel={() => setIsAddSubCategory(false)}
                                        hideAddCategory={true}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                    {showStockPicker && (
                        <StockImagePicker
                            onSelect={handleStockSelect}
                            onCancel={() => setShowStockPicker(false)}
                        />
                    )}
                </main >
                <Footer />
            </div >
        </div >
    );
};

export default ServicePage;